var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.303,
    height: 80.976,
    viewBox: "0 0 95.303 80.976",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10172",
    "data-name": "Group 10172",
    transform: "translate(-829.195 -520.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10147",
    "data-name": "Group 10147",
    transform: "translate(829.195 520.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12405",
    "data-name": "Path 12405",
    d: "M408.307,279.217a11.921,11.921,0,1,1,23.843.1,11.922,11.922,0,0,1-23.843-.1Z",
    transform: "translate(-385.162 -254.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12406",
    "data-name": "Path 12406",
    d: "M476.338,252.517H383.991a1.477,1.477,0,0,0-1.478,1.478v78.02a1.477,1.477,0,0,0,1.478,1.478h92.347a1.478,1.478,0,0,0,1.478-1.478v-78.02A1.478,1.478,0,0,0,476.338,252.517Zm-5.408,65.521c-.648-1.02-1.2-1.879-1.74-2.744q-9.512-15.2-19.024-30.392c-1.445-2.307-3.269-2.689-5.477-1.095q-15.208,10.982-30.4,21.987c-.336.243-.677.479-1.118.79-.254-.372-.474-.675-.673-.991q-3.365-5.345-6.727-10.691c-1.328-2.1-3.167-2.445-5.183-1.014q-5.23,3.714-10.474,7.409c-.2.144-.423.269-.716.455V259.358H470.93Z",
    transform: "translate(-382.513 -252.517)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.d70a563113cf547f57635e25c9145135.svg";
export { ForwardRef as ReactComponent };